import PropTypes from 'prop-types'
import { useLayout } from '@flix/common/elements/layout'
import { useButtonHandlers } from '../../../../elements/controls/index.js'
import { ArticleBlockContent } from './ArticleBlockContent'
import { BlockBackgrounded } from './BlockBackgrounded'
import { BlockGlowing } from './BlockGlowing'

const makeArticleBlock =
  (BlockComponent) =>
  ({
    article,
    blogSlug,
    highlight = article.pinned || article.highlighted,
    pinnedImgIsWide,
    onPress,
    style,
    showCategory = true,
  }) => {
    const { onLayout, width } = useLayout()
    const { handlers } = useButtonHandlers()
    const pressHandler = onPress ?? handlers.viewArticle

    return (
      <BlockComponent
        onLayout={onLayout}
        onPress={pressHandler && (() => pressHandler(article, blogSlug))}
        highlight={highlight}
        style={style}
      >
        <ArticleBlockContent
          width={width}
          highlight={highlight}
          pinnedImgIsWide={pinnedImgIsWide}
          article={article}
          showCategory={showCategory}
        />
      </BlockComponent>
    )
  }

export const ArticleBlockBackgrounded = makeArticleBlock(BlockBackgrounded)
export const ArticleBlockGlowing = makeArticleBlock(BlockGlowing)

const propTypes = {
  article: PropTypes.object.isRequired,
  onPress: PropTypes.func,
  pinnedImgIsWide: PropTypes.bool,
  showCategory: PropTypes.bool,
  highlight: PropTypes.bool,
}

ArticleBlockBackgrounded.propTypes = propTypes
ArticleBlockGlowing.propTypes = propTypes
